
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5PobO", function(module, exports) {
/* AISmartButtonWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $5spQU = parcelRequire("5spQU");


var $gdv5Z = parcelRequire("gdv5Z");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $l998X = parcelRequire("l998X");





var $fFa3V = parcelRequire("fFa3V");


var $1Whri = parcelRequire("1Whri");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");





var $8unJx = parcelRequire("8unJx");


var $4Zhx7 = parcelRequire("4Zhx7");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $7fKGk = parcelRequire("7fKGk");







/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $jO3S6 = parcelRequire("jO3S6");


var $b6KjD = parcelRequire("b6KjD");

const $283eb6140a5633fc$var$styles = {
    miniModalMainContainer: "_2rko12b0 _1bsb1kdj _bfhkhp5a _16qs130s _1e0c1txw _4cvr1h6o _1bah1h6o",
    rovoIcon: "_1bsbckbl _4t3ickbl"
};
const $283eb6140a5633fc$export$a33efecb32878e39 = ({ topOffset: topOffset, isNav4Enabled: isNav4Enabled })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $b6KjD.MainWrapper), {
        mode: "mini-modal",
        isNav4Enabled: isNav4Enabled,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            testId: "conversation-assistant-mini-modal-main-container",
            xcss: $283eb6140a5633fc$var$styles.miniModalMainContainer,
            style: {
                height: `min(320px, calc(100vh - ${topOffset}px))`
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $283eb6140a5633fc$var$styles.rovoIcon,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jO3S6.LazyAnimatedRovoIcon), {
                    alt: "",
                    testId: "rovo-loading-animation"
                })
            })
        })
    });
};





const $d5247c21dfb549e7$export$d4c72bab9d6cc13a = {
    isMiniModalStaticPositioningEnabled: false
};
const $d5247c21dfb549e7$var$rovoChatRefreshV2ConfigDefaultValues = JSON.stringify($d5247c21dfb549e7$export$d4c72bab9d6cc13a);
const $d5247c21dfb549e7$export$6ae9a55e1ff15aba = ()=>{
    const isRolloutInJiraEnabled = (0, $c6GJD.default).getExperimentValue('jira_ai_rovo_button', 'treatment', 'A') === 'B';
    const rovoChatRefreshV2ConfigResponse = isRolloutInJiraEnabled || (0, $c6GJD.default).getExperimentValue('rovo_chat_refresh_v1_experiment', 'isRenderRefreshEnabled', false) ? (0, $c6GJD.default).getExperimentValue('rovo_chat_refresh_v2_config', 'value', $d5247c21dfb549e7$var$rovoChatRefreshV2ConfigDefaultValues) : $d5247c21dfb549e7$var$rovoChatRefreshV2ConfigDefaultValues;
    let rovoChatRefreshV2Config = $d5247c21dfb549e7$export$d4c72bab9d6cc13a;
    try {
        rovoChatRefreshV2Config = JSON.parse(rovoChatRefreshV2ConfigResponse);
    } catch (error) {
    // fail silently
    }
    return rovoChatRefreshV2Config;
};


// TODO: Remove this once we clean up the FG for mini modal static positioning
const $6aab261d18fe5fed$var$styles = {
    miniModalStyles: "_kqswstnw _1pby9y44 _1xi2idpf _94n51osq"
};

const $6aab261d18fe5fed$var$LazyAIMiniModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("avMJB")).then((module)=>({
            default: module.AIMiniModal
        })));

const $6aab261d18fe5fed$export$1f1f17d801cbb952 = ()=>{
    (parcelRequire("avMJB")).then((module)=>({
            default: module.AIMiniModal
        }));
};
const $6aab261d18fe5fed$export$f36d8da28b18d2c1 = (props)=>{
    const { isMiniModalStaticPositioningEnabled: isMiniModalStaticPositioningEnabled } = (0, $d5247c21dfb549e7$export$6ae9a55e1ff15aba)();
    const mousetrapRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const setContainerRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        mousetrapRef.current?.reset();
        if (!node) return;
        mousetrapRef.current = new (0, (/*@__PURE__*/$parcel$interopDefault($7fKGk)))(node);
    }, []);
    const suppressKeyPress = (event)=>{
        mousetrapRef.current?.bind(event.key.toLocaleLowerCase(), (e)=>e.stopPropagation());
    };
    const miniModal = (0, $42omo.useMemo)(()=>{
        // 48px = nav header height, 8px = object sidebar bottom padding, 16px = AI smart button bottom margin, 8px = extra margin so it doesn't align with nav header
        const defaultTopOffset = 80;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $283eb6140a5633fc$export$a33efecb32878e39), {
                topOffset: props.topOffset || defaultTopOffset,
                isNav4Enabled: props.isNav4Enabled
            }),
            children: /*#__PURE__*/ (0, $l998X.jsx)($6aab261d18fe5fed$var$LazyAIMiniModal, {
                ...props,
                topOffset: props.topOffset || defaultTopOffset
            })
        });
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: setContainerRef,
        onKeyDown: suppressKeyPress,
        xcss: (0, $1Whri.cx)(isMiniModalStaticPositioningEnabled ? undefined : $6aab261d18fe5fed$var$styles.miniModalStyles),
        testId: "ai-smart-button-mini-modal-wrapper",
        children: isMiniModalStaticPositioningEnabled && props.overrideMiniModalWrapper ? props.overrideMiniModalWrapper(miniModal) : miniModal
    });
};








/**
 * Isomorphic SSR-safe check if code is run in the browser environment
 * so we can use globals like window safely.
 */ const $f66f70f5625700d0$export$4e09c449d6c407f7 = ()=>{
    try {
        return typeof window !== 'undefined';
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
};


class $708496ba42c9c342$export$f4380d3820d95f34 {
    get hasTriggers() {
        return Boolean(this.triggerQueue.length);
    }
    addTrigger(featureId, featureName, featureDescription) {
        this.triggerQueue.push({
            nudge_id: crypto.randomUUID(),
            feature_details: {
                feature_id: featureId,
                feature_name: featureName || 'Debug Nudge',
                feature_description: featureDescription || 'A nudge added for debugging'
            },
            cta: {
                cta_action: 'ACTION'
            }
        });
    }
    addConvoStarter(convoStarterLabel) {
        this.triggerQueue.push({
            cta: {
                cta_action: 'CHAT',
                cta_label: convoStarterLabel || 'Debug Convo Starter'
            },
            nudge_id: crypto.randomUUID(),
            feature_details: {
                feature_id: 'convo-starter',
                feature_name: 'Debug Convo Starter',
                feature_description: 'A conversation starter for debugging'
            }
        });
    }
    clear() {
        this.triggerQueue = [];
    }
    useNextTrigger() {
        return this.triggerQueue.shift();
    }
    constructor(){
        this.triggerQueue = [];
    }
}


const $ed176a720650c8d6$export$a8ab20a5170c41b3 = ()=>{
    (0, $42omo.useEffect)(()=>{
        if (!(0, $f66f70f5625700d0$export$4e09c449d6c407f7)()) return;
        if (!(0, $dh538.fg)('aix_nudge_recommendation_migration_enabled')) return;
        if (!window?.AIX_DEBUG_NUDGE_TRIGGERS) window.AIX_DEBUG_NUDGE_TRIGGERS = new (0, $708496ba42c9c342$export$f4380d3820d95f34)();
        return ()=>{
            if (window.AIX_DEBUG_NUDGE_TRIGGERS) delete window.AIX_DEBUG_NUDGE_TRIGGERS;
        };
    }, []);
};



function $28312c7c4d66f65e$var$safeIsPointInRange(range, node, offset) {
    try {
        return range.isPointInRange(node, offset);
    } catch  {
        // some node types can throw, treat as "outside"
        return false;
    }
}
function $28312c7c4d66f65e$var$fullyInside(r, container) {
    return $28312c7c4d66f65e$var$safeIsPointInRange(container, r.startContainer, r.startOffset) && $28312c7c4d66f65e$var$safeIsPointInRange(container, r.endContainer, r.endOffset);
}
/**
 * Find the "main" ProseMirror for a given sidebar container:
 * Walk up from the sidebar to the nearest .ak-editor-content-area. Return its direct
 * child .ProseMirror (even if other editors exist deeper in the subtree).
 */ function $28312c7c4d66f65e$var$getMainProseMirrorForSidebar(sidebar) {
    const sidebarEl = typeof sidebar === 'string' && typeof document !== 'undefined' ? document.querySelector(sidebar) : sidebar;
    if (!sidebarEl) return null;
    const contentArea = sidebarEl.closest('.ak-editor-content-area');
    if (!contentArea) return null;
    for (const child of Array.from(contentArea.children)){
        if (child instanceof HTMLElement && child.classList.contains('ProseMirror')) return child;
    }
    return null;
}
function $28312c7c4d66f65e$var$countWords(text) {
    const t = text.trim();
    if (!t) return 0;
    try {
        const Segmenter = Intl?.Segmenter;
        if (Segmenter) {
            const seg = new Segmenter(undefined, {
                granularity: 'word'
            });
            let c = 0;
            for (const { isWordLike: isWordLike } of seg.segment(t))if (isWordLike) c++;
            return c;
        }
    } catch  {}
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    return t.split(/\s+/u).filter(Boolean).length;
}
function $28312c7c4d66f65e$export$f18468c773f95821(sidebar) {
    try {
        const editor = $28312c7c4d66f65e$var$getMainProseMirrorForSidebar(sidebar);
        if (!editor) return null;
        const doc = editor.ownerDocument ?? (typeof document !== 'undefined' ? document : null);
        if (!doc) return null;
        const sel = doc.getSelection?.();
        if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return null;
        // range covering just the editor's contents to test containment
        const container = doc.createRange();
        container.selectNodeContents(editor);
        // snapshot rangeCount up-front to avoid races if selection changes
        const rangeCount = sel.rangeCount;
        // require every selection range to be fully inside
        let text = '';
        for(let i = 0; i < rangeCount; i++){
            const r = sel.getRangeAt(i);
            if (!$28312c7c4d66f65e$var$fullyInside(r, container)) return null;
            const part = r.toString();
            text += text ? `\n${part}` : part;
        }
        return {
            text: text,
            words: $28312c7c4d66f65e$var$countWords(text),
            chars: text.length
        };
    } catch (err) {
        return null;
    }
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");








var $u9agA = parcelRequire("u9agA");


var $3gadb = parcelRequire("3gadb");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $fVUfS = parcelRequire("fVUfS");


var $6F6hl = parcelRequire("6F6hl");




parcelRequire("42omo");

const $737d2071d968b7f4$export$a0f6cb8061290bbb = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 17 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M7.74328 1.00957C8.3818 0.65712 9.16114 0.663595 9.79449 1.02899L15.9562 4.5864C16.601 4.95844 17.0002 5.64868 17.0002 6.39226V13.5072C17.0002 14.2537 16.6035 14.9409 15.9567 15.3128L11.3249 17.9869C11.335 17.9584 11.3447 17.9297 11.3539 17.9008C11.4399 17.6343 11.4855 17.3526 11.4855 17.0646V9.94972C11.4855 8.97229 10.9656 8.07094 10.1176 7.58334L6.66492 5.59083V2.8348C6.66492 2.61763 6.69849 2.40549 6.76203 2.20466C6.91822 1.71863 7.25043 1.29786 7.70491 1.0352L7.70629 1.0344C7.71932 1.02688 7.73171 1.01854 7.74328 1.00957Z",
                fill: "var(--ds-icon-inverse, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M6.17528 1.91943L1.54352 4.59356C0.896734 4.9654 0.5 5.6526 0.5 6.39913V13.5141C0.5 14.2576 0.899073 14.9478 1.54394 15.3199L7.70569 18.8773C8.33903 19.2427 9.11841 19.2492 9.7569 18.8968C9.76847 18.8878 9.78078 18.8795 9.79381 18.872C10.2488 18.6095 10.5815 18.1886 10.7379 17.7023C10.8016 17.5013 10.8353 17.2889 10.8353 17.0715V14.3155L7.38278 12.3231C6.53497 11.8355 6.01472 10.9339 6.01472 9.95659V2.84167C6.01472 2.55414 6.06017 2.27283 6.14592 2.00659C6.15522 1.97735 6.16501 1.94829 6.17528 1.91943Z",
                fill: "var(--ds-icon-inverse, #FFFFFF)"
            })
        ]
    });





parcelRequire("42omo");

const $4a12766e4f768d03$export$9f3f45ad2aec3ab1 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.4352 0.363775C12.6088 -0.112663 11.592 -0.121106 10.7588 0.338447C10.7437 0.350143 10.7258 0.362058 10.7088 0.371866C10.1158 0.714353 9.68229 1.26299 9.47849 1.89674C9.39559 2.15859 9.35178 2.43521 9.35178 2.71837V6.31195L12.7406 8.26623L13.8592 8.91009C14.9656 9.54587 15.6439 10.7211 15.6439 11.9956V21.2728C15.6439 21.6482 15.5845 22.0155 15.4723 22.3631C15.4603 22.4007 15.4477 22.4381 15.4344 22.4753L21.4779 18.9885C22.3219 18.5036 22.8395 17.6076 22.8395 16.6342V7.35705C22.8395 6.38749 22.3187 5.48749 21.4773 5.00239L19.9351 4.11389L13.4352 0.363775Z",
                fill: "var(--ds-surface, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.66999 18.9977L4.10278 19.8244L10.7097 23.6363C11.5361 24.1126 12.553 24.1211 13.3861 23.6616C13.4012 23.6499 13.4173 23.6391 13.4343 23.6293C14.0279 23.287 14.462 22.7382 14.6662 22.1042C14.7492 21.8421 14.7931 21.5651 14.7931 21.2817V17.6881L11.2961 15.6713L10.2885 15.0902C9.18226 14.4544 8.50344 13.2789 8.50344 12.0045V2.7274C8.50344 2.35249 8.56274 1.9857 8.67462 1.63854C8.68676 1.60041 8.69954 1.56253 8.71294 1.5249L2.66944 5.01169C1.82552 5.49653 1.30786 6.39257 1.30786 7.36597V16.6431C1.30786 17.6127 1.82857 18.5126 2.66999 18.9977Z",
                fill: "var(--ds-surface, #FFFFFF)"
            })
        ]
    });


const $8ae48bddb3670e27$var$ANIMATION_DURATION = 0.65;
const $8ae48bddb3670e27$var$buttonAnimation = null;
const $8ae48bddb3670e27$var$atlaskitCssStyles = {
    pressableStyles: "_2rkopb1k _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _4t3i1a70 _1bsb1a70 _bfhk1j28",
    pressableStylesRefreshed: "_2rko1tm3 _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _4t3ickbl _1bsbckbl _bfhk1j28",
    boxStyles: "_2rkopb1k _p12f1a70 _kqswh2mm _pdyk1y4g _rfx3pb1k _1cs8stnw _1kt9b3bt _txdon80n _kfgt1a70 _1mp41a70 _1rus1o4i _qc5os58n _14mj1ahh _uoe3t94y _1rect94y _70xrt94y _1k96t94y _18postnw _3p6m17h5 _aetrb3bt _1bqq1mrw _z0ai1osq _1qdg1osq _15l21n1a _19do1n1a _1b1b120f _19si120f _1xqclefx",
    boxStylesRefreshed: "_2rko1tm3 _v564s58n _1bsbckbl _4t3ickbl _1o9zidpf _kqswh2mm _bfhk1aqn _16qs1a41 _o7ksf4ca _1llw1mwg _d0altlke _1q8wws4j",
    wrapperStylesDynamic: "_5sagf71h _tip8kb7n _1pglp3kn _j7hq16y3"
};
const $8ae48bddb3670e27$export$a51986b9c6d9ac89 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ onClick: onClick, isDisabled: isDisabled = false, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $8ae48bddb3670e27$var$atlaskitCssStyles.boxStyles
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
            testId: "platform-ai-button",
            xcss: $8ae48bddb3670e27$var$atlaskitCssStyles.pressableStyles,
            onClick: onClick,
            isDisabled: isDisabled,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            ref: ref,
            interactionName: "rovo-button-click",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                    children: " Rovo Button "
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $737d2071d968b7f4$export$a0f6cb8061290bbb), {})
            ]
        })
    });
});
const $8ae48bddb3670e27$export$c645d585c7f17c83 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ onClick: onClick, isDisabled: isDisabled = false, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $8ae48bddb3670e27$var$atlaskitCssStyles.boxStylesRefreshed
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
            testId: "platform-ai-button",
            xcss: $8ae48bddb3670e27$var$atlaskitCssStyles.pressableStylesRefreshed,
            onClick: onClick,
            isDisabled: isDisabled,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            ref: ref,
            interactionName: "rovo-button-click",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                    children: " Rovo Button "
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $4a12766e4f768d03$export$9f3f45ad2aec3ab1), {})
            ]
        })
    });
});


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $cUcZ5 = parcelRequire("cUcZ5");


var $9QtOT = parcelRequire("9QtOT");

var $glqpS = parcelRequire("glqpS");





var $e4AZE = parcelRequire("e4AZE");


var $8MJIs = parcelRequire("8MJIs");

const $94fd2d8a9380d7bf$var$NUDGE_DISMISS_TIMEOUT = 30000;
const $94fd2d8a9380d7bf$var$ANIMATION_DURATION = 200;
const $94fd2d8a9380d7bf$export$50a342ac0fc7ff57 = ()=>{
    const { fireRovoButtonUIEvent: fireRovoButtonUIEvent } = (0, $4Zhx7.useRovoButtonEventsInstrumentation)();
    const { changeView: changeView } = (0, $glqpS.useViewAIActions)();
    const surfaceMetadata = (0, $9QtOT.useAISurfaceMetadata)();
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [triggerId] = (0, $42omo.useState)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
    const [isNudgeVisible, setIsNudgeVisible] = (0, $42omo.useState)(false);
    const [dismissedIds, setDismissedIds] = (0, $42omo.useState)([]);
    const selectedNudges = (0, $9QtOT.useAINudges)();
    const [acceptedIds, setAcceptedIds] = (0, $42omo.useState)([]);
    const [prevNudge, setPrevNudge] = (0, $42omo.useState)(null);
    const [isMouseHovering, setIsMouseHovering] = (0, $42omo.useState)(false);
    const hoverTimerRef = (0, $42omo.useRef)(null);
    const potentialActiveNudge = (0, $42omo.useMemo)(()=>{
        /**
     * Nudge must not be previously dismissed or accepted
     * to be considered active.
     */ return selectedNudges.find((nudge)=>!dismissedIds.includes(nudge.id) && !acceptedIds.includes(nudge.id));
    }, [
        selectedNudges,
        dismissedIds,
        acceptedIds
    ]);
    const { isNudgeThrottled: isNudgeThrottled, isLoading: isNudgeThrottlingStateLoading } = (0, $e4AZE.useFetchNudgeThrottlingState)({
        triggerId: triggerId,
        hasNudgeToShow: !!potentialActiveNudge
    });
    const activeNudge = (0, $42omo.useMemo)(()=>{
        if (isNudgeThrottlingStateLoading || !potentialActiveNudge) return null;
        if (isNudgeThrottled) {
            setDismissedIds((ids)=>[
                    ...ids,
                    potentialActiveNudge.id
                ]);
            const nudgeId = `${potentialActiveNudge.title} - ${potentialActiveNudge.id}`;
            fireRovoButtonUIEvent({
                source: surfaceMetadata.contentType,
                action: 'throttled',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiRovoProactiveNudge',
                attributes: {
                    pageMode: surfaceMetadata.pageMode,
                    id: potentialActiveNudge.id,
                    nudgeId: nudgeId
                },
                product: surfaceMetadata.product
            });
            return null;
        }
        return potentialActiveNudge;
    }, [
        potentialActiveNudge,
        isNudgeThrottlingStateLoading,
        isNudgeThrottled,
        fireRovoButtonUIEvent,
        surfaceMetadata
    ]);
    (0, $42omo.useEffect)(()=>{
        if (activeNudge !== prevNudge) {
            setPrevNudge(activeNudge);
            if (activeNudge && activeNudge?.id !== prevNudge?.id) {
                const nudgeId = `${activeNudge.title} - ${activeNudge.id}`;
                fireRovoButtonUIEvent({
                    source: surfaceMetadata.contentType,
                    action: 'rendered',
                    actionSubject: 'rovoButton',
                    actionSubjectId: 'aiRovoProactiveNudge',
                    attributes: {
                        pageMode: surfaceMetadata.pageMode,
                        id: activeNudge.id,
                        nudgeId: nudgeId
                    },
                    product: surfaceMetadata.product
                });
                window.requestAnimationFrame(()=>{
                    /**
           * Needs to be set to visible in next tick, otherwise
           * it will not animate
           */ setIsNudgeVisible(true);
                });
            }
        }
    }, [
        activeNudge,
        prevNudge,
        fireRovoButtonUIEvent,
        surfaceMetadata
    ]);
    const onDismissClick = (0, $42omo.useCallback)(()=>{
        if (activeNudge) {
            setDismissedIds((ids)=>{
                return [
                    ...ids,
                    activeNudge.id
                ];
            });
            const nudgeId = `${activeNudge.title} - ${activeNudge.id}`;
            fireRovoButtonUIEvent({
                source: surfaceMetadata.contentType,
                action: 'dismissed',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiRovoProactiveNudge',
                attributes: {
                    pageMode: surfaceMetadata.pageMode,
                    id: activeNudge.id,
                    dismissedMethod: 'manual',
                    nudgeId: nudgeId
                },
                product: surfaceMetadata.product
            });
        }
    }, [
        activeNudge,
        fireRovoButtonUIEvent,
        surfaceMetadata
    ]);
    const onNudgeClick = (0, $42omo.useCallback)(()=>{
        if (activeNudge) {
            const nudgeId = `${activeNudge.title} - ${activeNudge.id}`;
            if (activeNudge.viewConfig) changeView(activeNudge);
            activeNudge.onClick?.();
            setAcceptedIds((ids)=>{
                return [
                    ...ids,
                    activeNudge.id
                ];
            });
            setDismissedIds((ids)=>{
                return [
                    ...ids,
                    activeNudge.id
                ];
            });
            fireRovoButtonUIEvent({
                source: surfaceMetadata.contentType,
                action: 'clicked',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiRovoProactiveNudge',
                attributes: {
                    pageMode: surfaceMetadata.pageMode,
                    id: activeNudge.id,
                    nudgeId: nudgeId
                },
                product: surfaceMetadata.product
            });
        }
    }, [
        activeNudge,
        changeView,
        fireRovoButtonUIEvent,
        surfaceMetadata
    ]);
    const onWrapperMouseEnter = (0, $42omo.useCallback)(()=>{
        setIsMouseHovering(true);
        const nudgeId = activeNudge ? `${activeNudge.title} - ${activeNudge.id}` : '';
        hoverTimerRef.current = setTimeout(()=>{
            fireRovoButtonUIEvent({
                source: surfaceMetadata.contentType,
                action: 'hovered',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiRovoProactiveNudge',
                attributes: {
                    product: surfaceMetadata.product,
                    productPage: surfaceMetadata.contentType,
                    pageMode: surfaceMetadata.pageMode,
                    nudgeId: nudgeId
                },
                product: surfaceMetadata.product
            });
        }, 1000);
    }, [
        fireRovoButtonUIEvent,
        surfaceMetadata,
        activeNudge
    ]);
    const onWrapperMouseLeave = (0, $42omo.useCallback)(()=>{
        setIsMouseHovering(false);
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
    }, []);
    (0, $42omo.useEffect)(()=>{
        let timeoutId;
        let slideoutTimeoutId;
        if (activeNudge && !isMouseHovering) {
            timeoutId = setTimeout(()=>{
                setDismissedIds((ids)=>[
                        ...ids,
                        activeNudge.id
                    ]);
                fireRovoButtonUIEvent({
                    source: surfaceMetadata.contentType,
                    action: 'dismissed',
                    actionSubject: 'rovoButton',
                    actionSubjectId: 'aiRovoProactiveNudge',
                    attributes: {
                        pageMode: surfaceMetadata.pageMode,
                        id: activeNudge.id,
                        timerDuration: $94fd2d8a9380d7bf$var$NUDGE_DISMISS_TIMEOUT,
                        dismissedMethod: 'timer_expired'
                    },
                    product: surfaceMetadata.product
                });
            }, $94fd2d8a9380d7bf$var$NUDGE_DISMISS_TIMEOUT);
            slideoutTimeoutId = setTimeout(()=>{
                setIsNudgeVisible(false);
            }, $94fd2d8a9380d7bf$var$NUDGE_DISMISS_TIMEOUT - $94fd2d8a9380d7bf$var$ANIMATION_DURATION);
        }
        /**
     * On mouse enter, isMouseHovering is set to true, will trigger
     *  cleanup function to clear timeout.
     */ return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
            if (slideoutTimeoutId) clearTimeout(slideoutTimeoutId);
        };
    }, [
        activeNudge,
        fireRovoButtonUIEvent,
        isMouseHovering,
        surfaceMetadata.contentType,
        surfaceMetadata.pageMode,
        surfaceMetadata.product
    ]);
    if (!activeNudge) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8MJIs.NudgeContent), {
        activeNudge: activeNudge,
        isNudgeVisible: isNudgeVisible,
        onWrapperMouseEnter: onWrapperMouseEnter,
        onWrapperMouseLeave: onWrapperMouseLeave,
        onNudgeClick: onNudgeClick,
        onDismissClick: onDismissClick
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
























// TODO: Extract and use factory pattern for different trigger types.
const $c6f35ad21ae02898$var$ROVO_BUTTON_TRIGGER_TYPE = 'ROVO_BUTTON_NUDGE_PAGE_LOAD';
const $c6f35ad21ae02898$var$CONVO_AI_URL = '/gateway/api/assist/api/ai/v2/ai-feature/proactive';
const $c6f35ad21ae02898$export$921bdedcb199d207 = async ({ triggerId: triggerId, pageUrl: pageUrl, product: product })=>{
    if ((0, $f66f70f5625700d0$export$4e09c449d6c407f7)() && window.AIX_DEBUG_NUDGE_TRIGGERS?.hasTriggers) return {
        triggers: [
            {
                recommendations: [
                    {
                        recommendation_details: window.AIX_DEBUG_NUDGE_TRIGGERS?.useNextTrigger()
                    }
                ]
            }
        ]
    };
    const request = {
        ai_feature_input: {
            triggers: [
                {
                    trigger_id: triggerId,
                    trigger_details: {
                        page_url: pageUrl
                    },
                    trigger_type: $c6f35ad21ae02898$var$ROVO_BUTTON_TRIGGER_TYPE
                }
            ]
        }
    };
    const response = await fetch($c6f35ad21ae02898$var$CONVO_AI_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Product': product,
            'X-Experience-Id': 'proactive-ai-rovo-button'
        },
        body: JSON.stringify(request)
    });
    if (!response.ok) throw new Error(`Error fetching agent recommendations and convo starters, status code: ${response.status}`);
    // Allow error to raise if response is not valid JSON
    // Allow undefined to be returned if ai_feature_output is not present
    return (await response.json())?.ai_feature_output;
};


const $6aab903d18d9f207$export$dbee8b6a491a53c = (triggerId, shouldTrigger, pageUrl, product)=>{
    const [error, setError] = (0, $42omo.useState)();
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [recommendations, setRecommendations] = (0, $42omo.useState)(undefined);
    const [prevUrl, setPrevUrl] = (0, $42omo.useState)();
    const makeNudgeRecommendationsRequest = (0, $42omo.useCallback)(async ()=>{
        if (!(0, $dh538.fg)('aix_nudge_recommendation_migration_enabled')) {
            setLoading(false);
            return;
        }
        if (!product || // invalid request parameter
        !shouldTrigger || // unsupported, no nudges to recommend
        pageUrl === prevUrl // prevent duplicate page requests
        ) {
            setLoading(false);
            return;
        }
        // Begin new request under valid conditions
        if (!loading && product && shouldTrigger && pageUrl !== prevUrl) {
            setLoading(true);
            setError(undefined);
            setRecommendations(undefined);
            return;
        }
        try {
            const response = await (0, $c6f35ad21ae02898$export$921bdedcb199d207)({
                triggerId: triggerId,
                pageUrl: pageUrl,
                product: product
            });
            setRecommendations(response?.triggers.flatMap((trigger)=>trigger.recommendations.map((recommendation)=>recommendation.recommendation_details)));
            setError(undefined);
        } catch (error) {
            setRecommendations(undefined);
            setError(error);
        } finally{
            setPrevUrl(pageUrl);
            setLoading(false);
        }
    }, [
        loading,
        pageUrl,
        prevUrl,
        product,
        shouldTrigger,
        triggerId
    ]);
    (0, $42omo.useEffect)(()=>{
        makeNudgeRecommendationsRequest();
    }, [
        loading,
        makeNudgeRecommendationsRequest
    ]);
    return (0, $42omo.useMemo)(()=>({
            recommendations: loading ? undefined : recommendations,
            loading: loading,
            error: error
        }), [
        loading,
        error,
        recommendations
    ]);
};





const $1836b2329377cb46$var$NUDGE_DISMISS_TIMEOUT = 30000;
const $1836b2329377cb46$var$ANIMATION_DURATION = 200;
const $1836b2329377cb46$export$50a342ac0fc7ff57 = ()=>{
    const [dismissedIds, setDismissedIds] = (0, $42omo.useState)({});
    const [acceptedIds, setAcceptedIds] = (0, $42omo.useState)({});
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [triggerId] = (0, $42omo.useState)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
    const [isNudgeVisible, setIsNudgeVisible] = (0, $42omo.useState)(false);
    const [prevNudgeId, setPrevNudgeId] = (0, $42omo.useState)(null);
    const [isMouseHovering, setIsMouseHovering] = (0, $42omo.useState)(false);
    const hoverTimerRef = (0, $42omo.useRef)(null);
    const registeredNudges = (0, $9QtOT.useAINudges)();
    const surfaceMetadata = (0, $9QtOT.useAISurfaceMetadata)();
    const { fireRovoButtonUIEvent: fireRovoButtonUIEvent } = (0, $4Zhx7.useRovoButtonEventsInstrumentation)();
    const { changeView: changeView } = (0, $glqpS.useViewAIActions)();
    const { recommendations: recommendations, loading: loading, error: error } = (0, $6aab903d18d9f207$export$dbee8b6a491a53c)(triggerId, Boolean(registeredNudges.length), (0, $f66f70f5625700d0$export$4e09c449d6c407f7)() ? window.location.href : '', surfaceMetadata?.product);
    const recommendation = (0, $42omo.useMemo)(()=>recommendations?.[0], [
        recommendations
    ]);
    const activeNudge = (0, $42omo.useMemo)(()=>{
        if (loading || error || !recommendation) return null;
        /**
     * Nudge must not be previously dismissed or accepted
     * to be considered active.
     */ if (dismissedIds[recommendation.nudge_id] || acceptedIds[recommendation.nudge_id]) return null;
        return registeredNudges.find((nudge)=>nudge.id === recommendation.feature_details.feature_id) || null;
    }, [
        loading,
        error,
        recommendation,
        dismissedIds,
        acceptedIds,
        registeredNudges
    ]);
    (0, $42omo.useEffect)(()=>{
        if (activeNudge && recommendation && recommendation.nudge_id !== prevNudgeId) {
            setPrevNudgeId(recommendation.nudge_id);
            const nudgeId = `${activeNudge.title} - ${activeNudge.id}`;
            fireRovoButtonUIEvent({
                source: surfaceMetadata.contentType,
                action: 'rendered',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiRovoProactiveNudge',
                attributes: {
                    pageMode: surfaceMetadata.pageMode,
                    id: activeNudge.id,
                    nudgeId: nudgeId
                },
                product: surfaceMetadata.product
            });
            window.requestAnimationFrame(()=>{
                /**
         * Needs to be set to visible in next tick, otherwise
         * it will not animate
         */ setIsNudgeVisible(true);
            });
        }
    }, [
        activeNudge,
        fireRovoButtonUIEvent,
        prevNudgeId,
        recommendation,
        surfaceMetadata
    ]);
    const onDismissClick = (0, $42omo.useCallback)(()=>{
        if (activeNudge && recommendation) {
            setDismissedIds((prevIds)=>({
                    ...prevIds,
                    [recommendation.nudge_id]: true
                }));
            const nudgeId = `${activeNudge.title} - ${activeNudge.id}`;
            fireRovoButtonUIEvent({
                source: surfaceMetadata.contentType,
                action: 'dismissed',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiRovoProactiveNudge',
                attributes: {
                    pageMode: surfaceMetadata.pageMode,
                    id: activeNudge.id,
                    dismissedMethod: 'manual',
                    nudgeId: nudgeId
                },
                product: surfaceMetadata.product
            });
        }
    }, [
        activeNudge,
        fireRovoButtonUIEvent,
        recommendation,
        surfaceMetadata.contentType,
        surfaceMetadata.pageMode,
        surfaceMetadata.product
    ]);
    const onNudgeClick = (0, $42omo.useCallback)(()=>{
        if (activeNudge && recommendation) {
            setAcceptedIds((prevIds)=>({
                    ...prevIds,
                    [recommendation.nudge_id]: true
                }));
            if (activeNudge.viewConfig) changeView(activeNudge);
            activeNudge.onClick?.();
            const nudgeId = `${activeNudge.title} - ${activeNudge.id}`;
            fireRovoButtonUIEvent({
                source: surfaceMetadata.contentType,
                action: 'clicked',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiRovoProactiveNudge',
                attributes: {
                    pageMode: surfaceMetadata.pageMode,
                    id: activeNudge.id,
                    eventNudgeId: nudgeId
                },
                product: surfaceMetadata.product
            });
        }
    }, [
        activeNudge,
        changeView,
        fireRovoButtonUIEvent,
        recommendation,
        surfaceMetadata.contentType,
        surfaceMetadata.pageMode,
        surfaceMetadata.product
    ]);
    const onWrapperMouseEnter = (0, $42omo.useCallback)(()=>{
        setIsMouseHovering(true);
        hoverTimerRef.current = setTimeout(()=>{
            const nudgeId = activeNudge ? `${activeNudge.title} - ${activeNudge.id}` : '';
            fireRovoButtonUIEvent({
                source: surfaceMetadata.contentType,
                action: 'hovered',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiRovoProactiveNudge',
                attributes: {
                    product: surfaceMetadata.product,
                    productPage: surfaceMetadata.contentType,
                    pageMode: surfaceMetadata.pageMode,
                    nudgeId: nudgeId
                },
                product: surfaceMetadata.product
            });
        }, 1000);
    }, [
        activeNudge,
        fireRovoButtonUIEvent,
        surfaceMetadata.contentType,
        surfaceMetadata.pageMode,
        surfaceMetadata.product
    ]);
    const onWrapperMouseLeave = (0, $42omo.useCallback)(()=>{
        setIsMouseHovering(false);
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
    }, []);
    (0, $42omo.useEffect)(()=>{
        let timeoutId;
        let slideoutTimeoutId;
        if (activeNudge && recommendation && !isMouseHovering) {
            timeoutId = setTimeout(()=>{
                setDismissedIds((prevIds)=>({
                        ...prevIds,
                        [recommendation.nudge_id]: true
                    }));
                fireRovoButtonUIEvent({
                    source: surfaceMetadata.contentType,
                    action: 'dismissed',
                    actionSubject: 'rovoButton',
                    actionSubjectId: 'aiRovoProactiveNudge',
                    attributes: {
                        pageMode: surfaceMetadata.pageMode,
                        id: activeNudge.id,
                        timerDuration: $1836b2329377cb46$var$NUDGE_DISMISS_TIMEOUT,
                        dismissedMethod: 'timer_expired'
                    },
                    product: surfaceMetadata.product
                });
            }, $1836b2329377cb46$var$NUDGE_DISMISS_TIMEOUT);
            slideoutTimeoutId = setTimeout(()=>{
                setIsNudgeVisible(false);
            }, $1836b2329377cb46$var$NUDGE_DISMISS_TIMEOUT - $1836b2329377cb46$var$ANIMATION_DURATION);
        }
        /**
     * On mouse enter, isMouseHovering is set to true, will trigger
     *  cleanup function to clear timeout.
     */ return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
            if (slideoutTimeoutId) clearTimeout(slideoutTimeoutId);
        };
    }, [
        activeNudge,
        fireRovoButtonUIEvent,
        isMouseHovering,
        recommendation,
        surfaceMetadata.contentType,
        surfaceMetadata.pageMode,
        surfaceMetadata.product
    ]);
    if (!activeNudge) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8MJIs.NudgeContent), {
        activeNudge: activeNudge,
        isNudgeVisible: isNudgeVisible,
        onWrapperMouseEnter: onWrapperMouseEnter,
        onWrapperMouseLeave: onWrapperMouseLeave,
        onNudgeClick: onNudgeClick,
        onDismissClick: onDismissClick
    });
};


const $2b8cbdbf5555f0cb$export$50a342ac0fc7ff57 = ()=>(0, $dh538.fg)('aix_nudge_recommendation_migration_enabled') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1836b2329377cb46$export$50a342ac0fc7ff57), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $94fd2d8a9380d7bf$export$50a342ac0fc7ff57), {});

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 



















parcelRequire("42omo");


var $lDwiy = parcelRequire("lDwiy");


var $6Htct = parcelRequire("6Htct");

const $a2843619989b2a54$export$854f6e3aeade3572 = (recommendation)=>({
        id: 'convo-starter',
        title: recommendation.cta.cta_label ?? '',
        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
                label: ""
            }),
        description: undefined,
        type: 'convo-starter-action',
        onClick: ()=>{},
        staticPrompt: recommendation.cta.cta_label ?? '',
        starterType: 'static',
        handleType: (0, $6Htct.HandleActionType).Chat
    });


const $ab6db1fc1f14351f$export$6c62f9c964ed3ae0 = (recommendations, availableNudges)=>{
    for (let recommendation of recommendations){
        if (recommendation.cta.cta_action === 'CHAT' && (0, $dh538.fg)('aix_convo_starter_nudge_enabled')) return {
            ...(0, $a2843619989b2a54$export$854f6e3aeade3572)(recommendation),
            recommendationNudgeId: recommendation.nudge_id
        };
        const matchedNudge = availableNudges.find((nudge)=>nudge.id === recommendation.feature_details.feature_id);
        const matchedNudgeByContextId = availableNudges.find((action)=>action.nudgeContext?.id === recommendation.feature_details.feature_id);
        if (matchedNudge) return {
            ...matchedNudge,
            recommendationNudgeId: recommendation.nudge_id
        };
        if (matchedNudgeByContextId) return {
            ...matchedNudgeByContextId,
            recommendationNudgeId: recommendation.nudge_id
        };
    }
    return undefined;
};









var $4acD6 = parcelRequire("4acD6");


/**
 * The state only resets when:
 * - Location Changes: User navigates to a different page
 * - Page Refresh: Browser refreshes the page (global variables reset)
 * What Doesn't Reset the State
 * - Component Re-renders: State persists
 * - Component Unmount/Remount: State persists (this is what you want)
 * - Button Disappears/Reappears: State persists
 */ let $4aa9df336e52f173$var$globalAcceptedNudges = [];
let $4aa9df336e52f173$var$globalDismissedNudges = [];
const $4aa9df336e52f173$export$2dd8f6b7dbe1b931 = ()=>{
    $4aa9df336e52f173$var$globalAcceptedNudges = [];
    $4aa9df336e52f173$var$globalDismissedNudges = [];
};
const $4aa9df336e52f173$export$2bad233bdabe73c4 = ()=>{
    const { setNudgesRefreshed: setNudgesRefreshed } = (0, $4acD6.useAISmartButtonActions)();
    const [location, setLocation] = (0, $42omo.useState)((0, $f66f70f5625700d0$export$4e09c449d6c407f7)() ? window.location.pathname : undefined);
    const [acceptedNudges, setAcceptedNudges] = (0, $42omo.useState)($4aa9df336e52f173$var$globalAcceptedNudges);
    const [dismissedNudges, setDismissedNudges] = (0, $42omo.useState)($4aa9df336e52f173$var$globalDismissedNudges);
    // Helper functions
    const addAcceptedNudge = (0, $42omo.useCallback)((id)=>{
        setAcceptedNudges((prev)=>{
            if (!prev.includes(id)) {
                const newNudges = [
                    ...prev,
                    id
                ];
                $4aa9df336e52f173$var$globalAcceptedNudges = newNudges;
                return newNudges;
            }
            return prev;
        });
    }, []);
    const addDismissedNudge = (0, $42omo.useCallback)((id)=>{
        setDismissedNudges((prev)=>{
            if (!prev.includes(id)) {
                const newNudges = [
                    ...prev,
                    id
                ];
                $4aa9df336e52f173$var$globalDismissedNudges = newNudges;
                return newNudges;
            }
            return prev;
        });
    }, []);
    const clearState = (0, $42omo.useCallback)(()=>{
        setNudgesRefreshed([]);
        setAcceptedNudges([]);
        setDismissedNudges([]);
        $4aa9df336e52f173$var$globalAcceptedNudges = [];
        $4aa9df336e52f173$var$globalDismissedNudges = [];
    }, [
        setNudgesRefreshed
    ]);
    const handleLocationChange = (0, $42omo.useCallback)(()=>{
        if (!(0, $f66f70f5625700d0$export$4e09c449d6c407f7)()) return;
        if (location !== window.location.pathname) {
            setLocation(window.location.pathname);
            clearState();
        }
    }, [
        clearState,
        location,
        setLocation
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $f66f70f5625700d0$export$4e09c449d6c407f7)()) return;
        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;
        window.history.pushState = function(...args) {
            originalPushState.apply(this, args);
            handleLocationChange();
        };
        window.history.replaceState = function(...args) {
            originalReplaceState.apply(this, args);
            handleLocationChange();
        };
        const unbind = (0, $fFa3V.bindAll)(window, [
            {
                type: 'popstate',
                listener: handleLocationChange
            }
        ]);
        return ()=>{
            if (!(0, $f66f70f5625700d0$export$4e09c449d6c407f7)()) return;
            unbind();
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, [
        handleLocationChange
    ]);
    return {
        acceptedNudges: acceptedNudges,
        dismissedNudges: dismissedNudges,
        addAcceptedNudge: addAcceptedNudge,
        addDismissedNudge: addDismissedNudge,
        clearState: clearState
    };
};



const $985914b5b9bbe42f$var$LazyAIProactiveNudgeRefreshed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("gUpG0")).then((module)=>({
            default: module.AIProactiveNudgeRefreshed
        })));
const $985914b5b9bbe42f$export$f46d440bb7a501f5 = ({ sidebarApi: sidebarApi, product: product })=>{
    const surfaceMetadata = (0, $9QtOT.useAISurfaceMetadata)();
    const [triggerId] = (0, $42omo.useState)(()=>crypto.randomUUID());
    const selectedNudges = (0, $9QtOT.useAINudgesRefreshed)();
    const shouldTrigger = Boolean(selectedNudges?.length);
    const pageUrl = (0, $f66f70f5625700d0$export$4e09c449d6c407f7)() ? `${window.location.origin}${window.location.pathname}` : '';
    const { recommendations: recommendations, loading: loading, error: error } = (0, $6aab903d18d9f207$export$dbee8b6a491a53c)(triggerId, shouldTrigger, pageUrl, surfaceMetadata?.product);
    const { acceptedNudges: acceptedNudges, dismissedNudges: dismissedNudges, addAcceptedNudge: addAcceptedNudge, addDismissedNudge: addDismissedNudge } = (0, $4aa9df336e52f173$export$2bad233bdabe73c4)();
    const potentialActiveNudgeLegacy = (0, $42omo.useMemo)(()=>{
        if ((0, $dh538.fg)('aix_nudge_recommendation_migration_enabled')) return null;
         /**
       * ConversationAction must not be previously dismissed or accepted
       * to be considered active.
       */ 
        return selectedNudges?.find((nudge)=>!dismissedNudges.includes(nudge.id) && !acceptedNudges.includes(nudge.id)) ?? null;
    }, [
        selectedNudges,
        dismissedNudges,
        acceptedNudges
    ]);
    const potentialActiveNudge = (0, $42omo.useMemo)(()=>{
        if (potentialActiveNudgeLegacy) return potentialActiveNudgeLegacy;
        if (loading || error || !recommendations?.length || !selectedNudges?.length) return null;
         // TODO: dismiss/accept nudge by its nudgeContext.id so we only need to check recommendations
        // Remove conversation starter if dismissed or accepted
        const availableRecommendations = recommendations.filter((recommendation)=>!dismissedNudges.includes(recommendation.feature_details.feature_id) && !acceptedNudges.includes(recommendation.feature_details.feature_id)); // Remove actions if dismissed or accepted
        const availableNudges = selectedNudges.filter((nudge)=>!dismissedNudges.includes(nudge.id) && !acceptedNudges.includes(nudge.id));
        return (0, $ab6db1fc1f14351f$export$6c62f9c964ed3ae0)(availableRecommendations, availableNudges) ?? null;
    }, [
        acceptedNudges,
        dismissedNudges,
        error,
        loading,
        potentialActiveNudgeLegacy,
        recommendations,
        selectedNudges
    ]);
    // Early exit if no nudge to show
    if (!potentialActiveNudge) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($985914b5b9bbe42f$var$LazyAIProactiveNudgeRefreshed, {
            sidebarApi: sidebarApi,
            product: product,
            potentialActiveNudge: potentialActiveNudge,
            addAcceptedNudge: addAcceptedNudge,
            addDismissedNudge: addDismissedNudge
        })
    });
};



const $c6dba64ff693e66f$var$i18n = (0, $cgtv4.defineMessages)({
    tooltipLabel: {
        id: "ai-smart-button.tooltip.label",
        defaultMessage: "Ask Rovo AI"
    }
});
const $c6dba64ff693e66f$var$styles = {
    buttonWrapper: "_kqswh2mm"
};
const $c6dba64ff693e66f$export$21695acdb18697b9 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ onClick: onClick, isDisabled: isDisabled, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, sidebarApi: sidebarApi, isRefreshed: isRefreshed, product: product, productPage: productPage, analyticsAttributes: analyticsAttributes }, ref)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { toggleConversationAssistantUIMode: toggleConversationAssistantUIMode } = (0, $8unJx.useRovoExperienceAPIStore)();
    const [canShowNudge, setCanShowNudge] = (0, $42omo.useState)(false);
    const [spotlightRendered, setSpotlightRendered] = (0, $42omo.useState)(false);
    const placementElementRef = (0, $42omo.useRef)(null);
    const onboardingSpotlightElementId = (0, $42omo.useMemo)(()=>{
        const isLiveOrEditPage = analyticsAttributes?.pageMode === 'live' || analyticsAttributes?.pageMode === 'edit';
        const isPageOrBlogpost = productPage === 'page' || productPage === 'blogpost';
        if (isPageOrBlogpost && isLiveOrEditPage) return `rovo-button-onboarding-spotlight-live-or-edit`;
        return `rovo-button-onboarding-spotlight`;
    }, [
        productPage,
        analyticsAttributes
    ]);
    const onboardingSpotlightExperimentCohort = (0, $42omo.useMemo)(()=>product === 'confluence' ? // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        (0, $c6GJD.default).getExperimentValue('confluence_rovo_button_onboarding_spotlight', 'cohort', 'not-enrolled', {
            fireExperimentExposure: false
        }) : 'not-enrolled', [
        product
    ]); // Handle "Get Started" button click from spotlight
    const handleGetStartedClick = (0, $42omo.useCallback)(()=>{
        if (sidebarApi) toggleConversationAssistantUIMode({
            targetMode: 'mini-modal',
            sidebarApi: sidebarApi
        });
    }, [
        sidebarApi,
        toggleConversationAssistantUIMode
    ]); // Set up event listeners for spotlight communication
    (0, $42omo.useEffect)(()=>{
        if (!(0, $f66f70f5625700d0$export$4e09c449d6c407f7)() || // TODO: fix and remove eslint disable
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        typeof document === 'undefined' || !isRefreshed || !(0, $dh538.fg)('rovo_button_onboarding_spotlight') || onboardingSpotlightExperimentCohort === 'not-enrolled') return;
        if (onboardingSpotlightExperimentCohort === 'control') {
            (0, $c6GJD.default).manuallyLogExperimentExposure('confluence_rovo_button_onboarding_spotlight');
            return;
        }
        if (!placementElementRef.current) return;
         // Listen for spotlight rendered event
        const handleSpotlightRendered = (event)=>{
            const customEvent = event;
            if (customEvent.detail?.elementId === onboardingSpotlightElementId) {
                setSpotlightRendered(true); // Log experiment exposure for non-control users after spotlight is rendered
                (0, $c6GJD.default).manuallyLogExperimentExposure('confluence_rovo_button_onboarding_spotlight');
            }
        }; // Listen for "Get Started" button click event
        const handleGetStartedEvent = (event)=>{
            const customEvent = event;
            if (customEvent.detail?.elementId === onboardingSpotlightElementId) handleGetStartedClick();
        }; // TODO: fix and remove eslint disable
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        const unbind = (0, $fFa3V.bindAll)(document, [
            {
                type: 'rovo-button-onboarding-spotlight-rendered',
                listener: handleSpotlightRendered
            },
            {
                type: 'rovo-button-onboarding-spotlight-get-started-click',
                listener: handleGetStartedEvent
            }
        ]);
        return ()=>{
            unbind();
        };
    }, [
        isRefreshed,
        handleGetStartedClick,
        onboardingSpotlightExperimentCohort,
        onboardingSpotlightElementId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isRefreshed || spotlightRendered) return;
        if (!(0, $dh538.fg)('rovo_button_onboarding_spotlight') && !canShowNudge) {
            setCanShowNudge(true);
            return;
        } // Give spotlight time to render (if it will) since it needs to run decisions logic
        const timeout = setTimeout(()=>{
            if (!spotlightRendered && !canShowNudge) setCanShowNudge(true);
        }, 1000);
        return ()=>clearTimeout(timeout);
    }, [
        isRefreshed,
        spotlightRendered,
        canShowNudge
    ]);
    const nudgeOrPlacement = (0, $42omo.useMemo)(()=>{
        if (!isRefreshed || !sidebarApi) return /*#__PURE__*/ (0, $l998X.jsx)((0, $2b8cbdbf5555f0cb$export$50a342ac0fc7ff57), {});
        const qualifiesForSpotlight = onboardingSpotlightExperimentCohort !== 'control' && onboardingSpotlightExperimentCohort !== 'not-enrolled';
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            children: [
                // eslint-disable-next-line @atlaskit/platform/no-preconditioning
                (0, $dh538.fg)('rovo_button_onboarding_spotlight') && qualifiesForSpotlight && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    id: onboardingSpotlightElementId,
                    ref: placementElementRef
                }),
                canShowNudge && /*#__PURE__*/ (0, $l998X.jsx)((0, $985914b5b9bbe42f$export$f46d440bb7a501f5), {
                    sidebarApi: sidebarApi,
                    product: product
                })
            ]
        });
    }, [
        isRefreshed,
        sidebarApi,
        product,
        canShowNudge,
        onboardingSpotlightExperimentCohort,
        onboardingSpotlightElementId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $c6dba64ff693e66f$var$styles.buttonWrapper,
        children: [
            nudgeOrPlacement,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                position: "left",
                content: formatMessage($c6dba64ff693e66f$var$i18n.tooltipLabel),
                hideTooltipOnClick: true,
                ignoreTooltipPointerEvents: true,
                children: isRefreshed ? /*#__PURE__*/ (0, $l998X.jsx)((0, $8ae48bddb3670e27$export$c645d585c7f17c83), {
                    onClick: onClick,
                    isDisabled: isDisabled,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    ref: ref
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $8ae48bddb3670e27$export$a51986b9c6d9ac89), {
                    onClick: onClick,
                    isDisabled: isDisabled,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    ref: ref
                })
            })
        ]
    });
});


const $cf41c6df33b899ca$var$ANIMATION_DURATION = 150;
const $cf41c6df33b899ca$var$styles = {
    wrapper: "_kqswh2mm",
    animatedMiniModalBefore: "_v564gsou _8hrz1x0m _3um015vq _tzy42wxo _t9ec1u4m _kdam1pry _m6k413u5 _sedt6rww",
    animatedMiniModalAfter: "_tzy4kb7n _t9ec1h7a _3um0ewfl _kdam1ogz"
};
const $cf41c6df33b899ca$export$bdf1977621b5251d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ product: product, sidebarApi: sidebarApi, productPage: productPage, analyticsAttributes: analyticsAttributes, isDisabled: isDisabled = false, ...delegatedProps }, forwardedRef)=>{
    const hoverTimerRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const { fireRovoButtonUIEvent: fireRovoButtonUIEvent } = (0, $4Zhx7.useRovoButtonEventsInstrumentation)();
    const { mode: mode, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable } = (0, $8unJx.useRovoExperienceAPIStore)();
    const [rovoButtonCanRender, setRovoButtonCanRender] = (0, $42omo.useState)(mode !== 'mini-modal');
    const [hasStartedPreloading, setHasStartedPreloading] = (0, $42omo.useState)(false);
    (0, $ed176a720650c8d6$export$a8ab20a5170c41b3)();
    (0, $42omo.useEffect)(()=>{
        setIsMiniModalAvailable(true);
        if (!(0, $f66f70f5625700d0$export$4e09c449d6c407f7)()) return;
        // Start preloading when mouse is within the bottom-right box (300px from bottom, 300px from right)
        const handleMouseMove = (event)=>{
            if ((0, $f66f70f5625700d0$export$4e09c449d6c407f7)() && !hasStartedPreloading) {
                const viewportHeight = window.innerHeight;
                const viewportWidth = window.innerWidth;
                const mouseY = event.clientY;
                const mouseX = event.clientX;
                const distanceFromBottom = viewportHeight - mouseY;
                const distanceFromRight = viewportWidth - mouseX;
                if (distanceFromBottom <= 300 && distanceFromRight <= 300) {
                    (0, $6aab261d18fe5fed$export$1f1f17d801cbb952)();
                    setHasStartedPreloading(true);
                }
            }
        };
        const unbind = (0, $fFa3V.bindAll)(window, [
            {
                type: 'mousemove',
                listener: handleMouseMove
            }
        ]);
        return ()=>{
            setIsMiniModalAvailable(false);
            (0, $f66f70f5625700d0$export$4e09c449d6c407f7)() && unbind();
        };
    }, [
        setIsMiniModalAvailable,
        hasStartedPreloading
    ]);
    (0, $42omo.useEffect)(()=>{
        fireRovoButtonUIEvent({
            source: productPage,
            action: 'rendered',
            actionSubject: 'rovoButton',
            actionSubjectId: 'aiSmartButton',
            attributes: {
                product: product,
                productPage: productPage,
                ...analyticsAttributes,
                version: 'refresh',
                legacy: false
            },
            product: product
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fireRovoButtonUIEvent,
        product,
        productPage
    ]);
    (0, $42omo.useEffect)(()=>{
        // Wait for the closing animation of modal to complete before showing the rovo button
        if (mode !== 'mini-modal') {
            setTimeout(()=>{
                setRovoButtonCanRender(true);
            }, $cf41c6df33b899ca$var$ANIMATION_DURATION);
            return;
        }
        setRovoButtonCanRender(false);
    }, [
        mode,
        setRovoButtonCanRender
    ]);
    const onAISmartButtonClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((e)=>{
        toggleConversationAssistantUIMode({
            targetMode: 'mini-modal',
            sidebarApi: sidebarApi
        });
        const selectionAttributes = {};
        if ((0, $dh538.fg)('platform_editor_ai_aifc_streaming')) {
            const counts = (0, $28312c7c4d66f65e$export$f18468c773f95821)(e.currentTarget);
            if (counts != null) {
                selectionAttributes.totalSelectedWords = counts.words;
                selectionAttributes.totalSelectedChars = counts.chars;
            }
        }
        fireRovoButtonUIEvent({
            source: productPage,
            action: 'clicked',
            actionSubject: 'rovoButton',
            actionSubjectId: 'aiRovoSmartButton',
            attributes: {
                product: product,
                productPage: productPage,
                ...analyticsAttributes,
                ...selectionAttributes,
                version: 'refresh'
            },
            product: product
        });
        setRovoButtonCanRender(false);
    }, [
        product,
        productPage,
        analyticsAttributes,
        fireRovoButtonUIEvent,
        toggleConversationAssistantUIMode,
        sidebarApi
    ]);
    const onAISmartButtonEnter = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        hoverTimerRef.current = setTimeout(()=>{
            fireRovoButtonUIEvent({
                source: productPage,
                action: 'hovered',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiSmartButton',
                attributes: {
                    product: product,
                    productPage: productPage,
                    ...analyticsAttributes,
                    version: 'refresh'
                },
                product: product
            });
        }, 1000);
    }, [
        fireRovoButtonUIEvent,
        product,
        productPage,
        analyticsAttributes
    ]);
    const onAISmartButtonLeave = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $cf41c6df33b899ca$var$styles.wrapper,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($cf41c6df33b899ca$var$styles.animatedMiniModalBefore, mode === 'mini-modal' && $cf41c6df33b899ca$var$styles.animatedMiniModalAfter),
                children: !sidebarApi.isSidebarOpen() && (!rovoButtonCanRender || hasStartedPreloading && (0, $c6GJD.default).getExperimentValue('rovo_button_premounting_mini_modal', 'isEnabled', false)) && /*#__PURE__*/ (0, $l998X.jsx)((0, $6aab261d18fe5fed$export$f36d8da28b18d2c1), {
                    product: product,
                    sidebarApi: sidebarApi,
                    ...delegatedProps
                })
            }),
            !sidebarApi.isSidebarOpen() && rovoButtonCanRender && /*#__PURE__*/ (0, $l998X.jsx)((0, $c6dba64ff693e66f$export$21695acdb18697b9), {
                ref: forwardedRef,
                onClick: onAISmartButtonClick,
                isDisabled: isDisabled,
                onMouseEnter: onAISmartButtonEnter,
                onMouseLeave: onAISmartButtonLeave,
                sidebarApi: sidebarApi,
                isRefreshed: true,
                product: product,
                productPage: productPage,
                analyticsAttributes: analyticsAttributes
            })
        ]
    });
});



var $8ETUZ = parcelRequire("8ETUZ");


var $lzcvT = parcelRequire("lzcvT");


var $7mpOv = parcelRequire("7mpOv");


var $bQm3c = parcelRequire("bQm3c");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $9wGTI = parcelRequire("9wGTI");


var $gz8ZY = parcelRequire("gz8ZY");


var $bmR0z = parcelRequire("bmR0z");


var $zCcSI = parcelRequire("zCcSI");

const $78fdc0b3db730c49$var$styles = {
    smartButtonWrapperStyles: "_kqswstnw _1pby16oo _1xi2idpf _94n5idpf"
};
function $78fdc0b3db730c49$export$f7d346730580e70({ contentId: contentId, contentType: contentType, pageMode: pageMode, isDisabled: isDisabled = false }) {
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { setSurfaceMetadata: setSurfaceMetadata } = (0, $8ETUZ.useSurfaceAIActions)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const sidebarApi = (0, $bmR0z.useCreateRovoExperienceSidebarController)();
    // Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback
    const isAIEnvEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai') : !(0, $lzcvT.isFedRamp)();
    const isEnabled = isAIEnvEnabled && isAIEnabledForContent && isRovoEnabledForContent;
    // 48px = nav header height, 8px = object sidebar bottom padding, 16px = AI smart button bottom margin, 8px = extra margin so it doesn't align with nav header
    const navbarOffset = 80;
    // From confluence/next/packages/content-types-header/src/ContentTypesHeader.tsx
    const OBJECT_HEADER_CONTAINER_HEIGHT = 56;
    // From platform/packages/editor/editor-shared-styles/src/consts/consts.ts
    const FULL_PAGE_EDITOR_TOOLBAR_HEIGHT = 40;
    // Calculate total vertical offset based on the maximum header height (occurs in edit mode)
    const totalOffset = FULL_PAGE_EDITOR_TOOLBAR_HEIGHT + OBJECT_HEADER_CONTAINER_HEIGHT + navbarOffset;
    // only needed for legacy button
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        setSurfaceMetadata({
            siteId: cloudId,
            product: 'confluence',
            contentType: contentType,
            pageMode: pageMode
        });
    }, [
        cloudId,
        setSurfaceMetadata,
        contentType,
        pageMode
    ]);
    // Memoize analytics attributes to prevent unnecessary re-renders
    const analyticsAttributes = (0, $42omo.useMemo)(()=>({
            pageMode: pageMode
        }), [
        pageMode
    ]);
    const overrideMiniModalWrapper = (0, $42omo.useMemo)(()=>(children)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $78fdc0b3db730c49$var$styles.smartButtonWrapperStyles
            }, children);
        }, []);
    const conversationAssistantConfig = (0, $zCcSI.useConversationAssistantConfig)({
        assistanceServiceConfigHeaders: {
            'x-issynthetic-traffic': 'false'
        },
        preventAbortRequestsOnStagingModalClose: (0, $9wGTI.fg)('cc-ai-prevent-staging-modal-req-abort'),
        preventAbortRequestsOnStandaloneChatClose: (0, $9wGTI.fg)('cc-ai-prevent-standalone-rovo-chat-req-abort')
    });
    if (!isEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).AI_MATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cf41c6df33b899ca$export$bdf1977621b5251d), {
        product: "confluence",
        cloudId: cloudId,
        orgId: orgId,
        isNav4Enabled: isNav4Enabled,
        sidebarApi: sidebarApi,
        productPage: contentType,
        analyticsAttributes: analyticsAttributes,
        isDisabled: isDisabled,
        topOffset: totalOffset,
        conversationAssistantConfig: conversationAssistantConfig,
        overrideMiniModalWrapper: overrideMiniModalWrapper
    }));
}
module.exports["AISmartButtonWrapper"] = $78fdc0b3db730c49$export$f7d346730580e70;

});

parcelRegister("4Zhx7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3pfAb = parcelRequire("3pfAb");


var $inPa6 = parcelRequire("inPa6");

const $4dadc02c4f362fc5$var$ANALYTICS_CHANNEL = (0, $3pfAb.FabricChannel).aiMate;
const $4dadc02c4f362fc5$export$8a94e432ef80d839 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireEventWithOptionalChannel = (0, $42omo.useCallback)((event, product)=>{
        const analyticsEvent = createAnalyticsEvent(event);
        if (product === 'confluence') {
            analyticsEvent.fire();
            return;
        }
        // it goes thru the aiMate analytics listener to avoid validation per product listener
        // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
        analyticsEvent.fire($4dadc02c4f362fc5$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent
    ]);
    const createEventPayload = (0, $42omo.useCallback)((payload)=>{
        if (payload.product === 'confluence') // confluence event validation frontend logic
        // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
        return {
            type: 'sendUIEvent',
            data: payload
        };
        if (payload.product === 'jira') // jira event validation frontend logic
        // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
        // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
        return {
            actionSubject: payload.actionSubject,
            action: payload.action,
            actionSubjectId: payload.actionSubjectId,
            attributes: payload.attributes
        };
        // for any other product type we should use the default event shape
        // also if there is a custom event channel, we also should use the default event shape
        return {
            eventType: 'ui',
            ...payload
        };
    }, []);
    const fireRovoButtonUIEvent = (0, $42omo.useCallback)((eventData)=>{
        // Only fire the event if product is defined
        if (!eventData.product) return;
        const event = createEventPayload(eventData);
        fireEventWithOptionalChannel(event, eventData.product);
    }, [
        fireEventWithOptionalChannel,
        createEventPayload
    ]);
    return {
        fireRovoButtonUIEvent: fireRovoButtonUIEvent
    };
};
module.exports["useRovoButtonEventsInstrumentation"] = $4dadc02c4f362fc5$export$8a94e432ef80d839;

});

parcelRegister("avMJB", function(module, exports) {

let $7a729a4edaccf7a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7a729a4edaccf7a0$var$load("7wimf").then(()=>parcelRequire('jK0BO'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("glqpS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4acD6 = parcelRequire("4acD6");

const $7ea9bbf63a271292$export$7c7acaa418085cd7 = ()=>{
    const { changeView: changeView, setProfileData: setProfileData, setShowConvoStarters: setShowConvoStarters } = (0, $4acD6.useAISmartButtonActions)();
    return (0, $42omo.useMemo)(()=>({
            changeView: /**
			 * Change the view of the ai actions.
			 */ changeView,
            setProfileData: /**
			 * Set the prefetched name for the ai actions.
			 */ setProfileData,
            setShowConvoStarters: /**
			 * Toggle convo starters on or off within ai actions.
			 */ setShowConvoStarters
        }), [
        changeView,
        setProfileData,
        setShowConvoStarters
    ]);
};
module.exports["useViewAIActions"] = $7ea9bbf63a271292$export$7c7acaa418085cd7;

});

parcelRegister("e4AZE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $fc521b38e71b39b6$var$CONVO_AI_URL = '/gateway/api/assist/api/ai/v2/ai-feature/proactive';
const $fc521b38e71b39b6$var$ROVO_BUTTON_NUDGE_LIMITER_TRIGGER_TYPE = 'ROVO_BUTTON_NUDGE_LIMITER';
const $fc521b38e71b39b6$export$7f1fbc078e6eb4f0 = async ({ triggerId: triggerId })=>{
    const request = {
        ai_feature_input: {
            triggers: [
                {
                    trigger_id: triggerId,
                    trigger_details: {},
                    trigger_type: $fc521b38e71b39b6$var$ROVO_BUTTON_NUDGE_LIMITER_TRIGGER_TYPE
                }
            ]
        }
    };
    const response = await fetch($fc521b38e71b39b6$var$CONVO_AI_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Product': 'confluence',
            'X-Experience-Id': 'proactive-ai-rovo-button'
        },
        body: JSON.stringify(request)
    });
    if (!response.ok) throw new Error(`Error fetching nudge throttling state, status code: ${response.status}`);
    const { ai_feature_output: ai_feature_output } = await response.json() ?? {};
    if (!ai_feature_output) throw new Error('No nudge throttling state returned from API');
    return ai_feature_output;
};


const $50c91a98a8166dac$export$63678417eaa09de8 = ({ triggerId: triggerId, hasNudgeToShow: hasNudgeToShow })=>{
    const [isNudgeThrottled, setIsNudgeThrottled] = (0, $42omo.useState)(false);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const makeNudgeThrottlingStateRequest = (0, $42omo.useCallback)(async ()=>{
        try {
            const nudgeThrottlingState = await (0, $fc521b38e71b39b6$export$7f1fbc078e6eb4f0)({
                triggerId: triggerId
            });
            setIsNudgeThrottled(nudgeThrottlingState.triggers[0].recommendations[0].recommendation_details.nudge_throttled);
        } catch (error) {
            setError(error);
        } finally{
            setIsLoading(false);
        }
    }, [
        triggerId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!hasNudgeToShow) return;
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
        const isNudgeThrottlingEnabled = (0, $dh538.fg)('rovo_button_nudge_throttling_enabled');
        const isNudgeRecommendationMigrationEnabled = (0, $dh538.fg)('aix_nudge_recommendation_migration_enabled');
        if (isNudgeThrottlingEnabled && !isNudgeRecommendationMigrationEnabled) {
            makeNudgeThrottlingStateRequest();
            return;
        }
        setIsLoading(false);
    }, [
        makeNudgeThrottlingStateRequest,
        hasNudgeToShow
    ]);
    return (0, $42omo.useMemo)(()=>{
        const getNudgeThrottlingState = ()=>{
            if (error || !isNudgeThrottled) return false;
            return isNudgeThrottled;
        };
        return {
            isNudgeThrottled: getNudgeThrottlingState(),
            isLoading: isLoading,
            error: error
        };
    }, [
        isNudgeThrottled,
        isLoading,
        error
    ]);
};
module.exports["useFetchNudgeThrottlingState"] = $50c91a98a8166dac$export$63678417eaa09de8;

});

parcelRegister("8MJIs", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");

const $e8d516257ce392b1$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    aiProactiveNudgeDismiss: {
        id: "ai-smart-button.ai-proactive-nudge.dismiss",
        defaultMessage: "Dismiss"
    }
});
const $e8d516257ce392b1$var$ANIMATION_DURATION = 200;
const $e8d516257ce392b1$var$NUDGE_WIDTH = '350px';
const $e8d516257ce392b1$var$styles = {
    wrapperStyles: "_1reo15vq _18m915vq _2rko1mok _v5644nwb _kqswstnw _1ltvidpf _o5721q9c _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1e0c1o8l _16qs130s _bfhk1aqn _4cvr1h6o _1bah1h6o _ta6yglyw",
    wrapperStylesUpdated: "_1reoewfl _18m9ewfl _2rko1mok _v5644nwb _kqswstnw _1ltvidpf _o5724jg8 _4t3i1wug _p12f1edt _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1e0c1o8l _16qs130s _bfhk1aqn _4cvr1e5h _1bah1e5h _ta6yglyw",
    newNudgeIconStyles: "_syaz5w2r",
    invisibleNudge: "_tzy4idpf _t9ecjq3t",
    visibleNudge: "_t9eci6v2 _tzy4kb7n",
    textStyle: "_1i4q4jg8",
    textWrapperStyle: "_y3gn1e5h _p12f1ris _1bsbuuw1 _o5724jg8",
    buttonOverride: "_11y51b66 _f7xt1wug _1unr1wug"
};
const $e8d516257ce392b1$export$9b98f181754d0f50 = /*#__PURE__*/ (0, $42omo.memo)(({ activeNudge: activeNudge, isNudgeVisible: isNudgeVisible, onWrapperMouseEnter: onWrapperMouseEnter, onWrapperMouseLeave: onWrapperMouseLeave, onNudgeClick: onNudgeClick, onDismissClick: onDismissClick })=>{
    const intl = (0, $8C5kA.default)();
    const isTextWrapEnabled = (0, $dh538.fg)('aix_convo_starters_nudge_text_wrap_enabled');
    const NudgeIcon = activeNudge.nudgeIcon ?? activeNudge.icon;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": "platform-ai-proactive-nudge" // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        ,
        onMouseEnter: onWrapperMouseEnter,
        onMouseLeave: onWrapperMouseLeave,
        className: (0, $gMc0m.default)([
            isTextWrapEnabled ? $e8d516257ce392b1$var$styles.wrapperStylesUpdated : $e8d516257ce392b1$var$styles.wrapperStyles,
            isNudgeVisible ? $e8d516257ce392b1$var$styles.visibleNudge : $e8d516257ce392b1$var$styles.invisibleNudge
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                grow: "fill",
                space: "space.025",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                        children: isTextWrapEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $e8d516257ce392b1$var$styles.buttonOverride,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                appearance: "subtle",
                                onClick: onNudgeClick,
                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                    space: "space.075",
                                    alignBlock: "start",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                            className: (0, $gMc0m.default)([
                                                $e8d516257ce392b1$var$styles.newNudgeIconStyles
                                            ]),
                                            children: /*#__PURE__*/ (0, $l998X.jsx)(NudgeIcon, {
                                                label: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: $e8d516257ce392b1$var$styles.textWrapperStyle,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                color: 'color.text.inverse',
                                                xcss: $e8d516257ce392b1$var$styles.textStyle,
                                                children: activeNudge.title
                                            })
                                        })
                                    ]
                                })
                            })
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "subtle",
                            onClick: onNudgeClick,
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.075",
                                alignBlock: "end",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                        className: (0, $gMc0m.default)([
                                            $e8d516257ce392b1$var$styles.newNudgeIconStyles
                                        ]),
                                        children: /*#__PURE__*/ (0, $l998X.jsx)(NudgeIcon, {
                                            label: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        color: 'color.text.inverse',
                                        children: activeNudge.title
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        testId: "platform-ai-proactive-nudge-dismiss",
                        appearance: "subtle",
                        label: intl.formatMessage($e8d516257ce392b1$export$a7357cdd1f0b0168.aiProactiveNudgeDismiss),
                        isTooltipDisabled: false,
                        tooltip: {
                            position: 'top'
                        },
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                ...iconProps,
                                size: "small",
                                color: "var(--ds-icon-inverse, #FFFFFF)"
                            }),
                        onClick: onDismissClick
                    })
                ]
            })
        })
    });
});
module.exports["NudgeContent"] = $e8d516257ce392b1$export$9b98f181754d0f50;

});

parcelRegister("gUpG0", function(module, exports) {

let $c4f5cb24fec6a3c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c4f5cb24fec6a3c1$var$load("8yTXr"),
    $c4f5cb24fec6a3c1$var$load("nZLoO"),
    $c4f5cb24fec6a3c1$var$load("76Z06"),
    $c4f5cb24fec6a3c1$var$load("38Uf2"),
    $c4f5cb24fec6a3c1$var$load("6CN9M"),
    $c4f5cb24fec6a3c1$var$load("78EJ0")
]).then(()=>parcelRequire('c0sxZ'));

});

parcelRegister("8ETUZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4acD6 = parcelRequire("4acD6");

const $5d7e3d9ca8f50cb2$export$75d7484b96e549ce = ()=>{
    const { setSelectors: setSelectors, setSurfaceMetadata: setSurfaceMetadata } = (0, $4acD6.useAISmartButtonActions)();
    return (0, $42omo.useMemo)(()=>({
            setSelectors: /**
			 * Sets selectors for filtering actions, suggested actions, and nudges.
			 */ setSelectors,
            setSurfaceMetadata: /**
			 * Sets metadata about the surface where AI features are used.
			 */ setSurfaceMetadata
        }), [
        setSelectors,
        setSurfaceMetadata
    ]);
};
module.exports["useSurfaceAIActions"] = $5d7e3d9ca8f50cb2$export$75d7484b96e549ce;

});

parcelRegister("eN3MW", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bee98af9586f2941$export$e6e415a985158eb3 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EZkxH",
    name: "QuickSummaryStreamingComponent",
    loader: async ()=>(await (parcelRequire("fMJlU"))).QuickSummaryStreamingEntryPoint
});
module.exports["QuickSummaryStreamingComponent"] = $bee98af9586f2941$export$e6e415a985158eb3;

});

parcelRegister("fMJlU", function(module, exports) {

let $b7de84be646a6a57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b7de84be646a6a57$var$load("jxz2q"),
    $b7de84be646a6a57$var$load("hcY7w"),
    $b7de84be646a6a57$var$load("1Jgsw"),
    $b7de84be646a6a57$var$load("h2QhJ"),
    $b7de84be646a6a57$var$load("1iUSs"),
    $b7de84be646a6a57$var$load("7EorR"),
    $b7de84be646a6a57$var$load("St9Nk"),
    $b7de84be646a6a57$var$load("9ijrN"),
    $b7de84be646a6a57$var$load("76Z06"),
    $b7de84be646a6a57$var$load("6wr18"),
    $b7de84be646a6a57$var$load("736as"),
    $b7de84be646a6a57$var$load("kUbT8"),
    $b7de84be646a6a57$var$load("ffEVr"),
    $b7de84be646a6a57$var$load("jrchu")
]).then(()=>parcelRequire('9zqwo'));

});


//# sourceMappingURL=ObjectSidebarControl.bca0a800.js.map
